import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import Header from '../components/Header';
import WhatsAppButton from '../components/WhatsAppButton';

interface RegistrationSuccessProps {
  onRegisterAnother: () => void;
}

const RegistrationSuccess: React.FC<RegistrationSuccessProps> = ({ onRegisterAnother }) => {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Si el usuario está autenticado, redirigir al dashboard
    if (isAuthenticated) {
      const timer = setTimeout(() => {
        navigate('/dashboard');
      }, 3000); // Redirigir después de 3 segundos

      return () => clearTimeout(timer);
    }
  }, [isAuthenticated, navigate]);

  return (
    <div className="page-wrapper">
      <Header />
      <main className="page-main">
        <div style={{ marginTop: '120px', minHeight: '60vh' }}>
          <div className="uk-section uk-section-primary uk-light">
            <div className="uk-container uk-container-large">
              <div className="uk-text-center">
                <i 
                  className="fas fa-check-circle" 
                  style={{ 
                    fontSize: '64px', 
                    color: 'var(--turquoise)', 
                    marginBottom: '20px' 
                  }}
                ></i>
                <h1 className="uk-heading-medium">¡Registro Exitoso!</h1>
                <p className="uk-text-lead">
                  Tu empresa ha sido registrada correctamente. {isAuthenticated ? 'Serás redirigido al dashboard en unos segundos...' : 'Recibirás un email de confirmación en breve.'}
                </p>
                {isAuthenticated ? (
                  <div>
                    <button 
                      className="uk-button uk-button-primary uk-button-large uk-margin-small-right"
                      onClick={() => navigate('/dashboard')}
                    >
                      <i className="fas fa-tachometer-alt uk-margin-small-right"></i>
                      Ir al Dashboard
                    </button>
                    <button 
                      className="uk-button uk-button-secondary uk-button-large"
                      onClick={onRegisterAnother}
                    >
                      Registrar otra empresa
                    </button>
                  </div>
                ) : (
                  <button 
                    className="uk-button uk-button-secondary uk-button-large"
                    onClick={onRegisterAnother}
                  >
                    Registrar otra empresa
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </main>
      <WhatsAppButton />
    </div>
  );
};

export default RegistrationSuccess;
